import React from 'react'

import SimpleMDEReact from 'react-simplemde-editor'
import 'simplemde/dist/simplemde.min.css'

function MarkdownEditor(props) {
  return (
    <div>
      <label className="markdown-editor-label" style={{
          color: 'rgb(33,150,243)',
          fontSize: '12px'
        }}>{props.title}</label>
      <SimpleMDEReact {...props} options={{
        showIcons: ['bold', 'italic', 'heading-1', 'heading-2', 'heading-3', 'quote', 'unordered-list', 'ordered-list', 'clean-block', 'link', 'image', 'preview', 'guide'],
        hideIcons: ['heading', 'side-by-side', 'fullscreen']
      }}/>
    </div>
  )
}

export default MarkdownEditor



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/MarkdownEditor/index.js